import { BaseballLineupPosition } from '@trackman/baseball-shared-components';
import React, { useEffect, useState } from 'react';
import { PositionBarWrapper } from './PositionBarStyles';
import { PositionItem } from './PositionItem';

interface IProps {
  filledPositions: string[];
  allPositions: BaseballLineupPosition[];
}

interface Position {
  position: string;
  success: boolean;
  error: boolean;
}

export const PositionBar: React.FC<IProps> = (props) => {
  const { filledPositions, allPositions } = props;

  const [positions, setPositions] = useState<Position[]>([]);

  useEffect(() => {
    setPositions(() => {
      return allPositions.map((position) => ({
        position: position,
        success: filledPositions.includes(position),
        error: filledPositions.filter((pos) => pos === position && pos !== 'DH').length > 1,
      }));
    });
  }, [filledPositions]);

  const getIsFirstSuccess = (index: number) => {
    if (index === 0) {
      return true;
    }

    if (positions[index - 1] && !positions[index - 1].success) {
      return true;
    }

    return positions[index - 1].error;
  };

  const getIsLastSuccess = (index: number) => {
    if (index + 1 === positions.length) {
      return true;
    }

    if (positions[index + 1] && !positions[index + 1].success) {
      return true;
    }

    return positions[index + 1].error;
  };

  const getIsFirstError = (index: number) => {
    if (index === 0) {
      return true;
    }

    if (positions[index - 1] && !positions[index - 1].error) {
      return true;
    }

    return !positions[index - 1].error;
  };

  const getIsLastError = (index: number) => {
    if (index + 1 === positions.length) {
      return true;
    }

    if (positions[index + 1] && !positions[index + 1].error) {
      return true;
    }

    return !positions[index + 1].error;
  };

  return (
    <PositionBarWrapper>
      {positions &&
        positions.map((position, index: number) => {
          return (
            <>
              <PositionItem
                position={position.position}
                success={position.success}
                isFirstSuccess={getIsFirstSuccess(index)}
                isLastSuccess={getIsLastSuccess(index)}
                isFirstError={getIsFirstError(index)}
                isLastError={getIsLastError(index)}
                error={position.error}
              />
            </>
          );
        })}
    </PositionBarWrapper>
  );
};
